import { render, staticRenderFns } from "./HandoverDevicesStep.vue?vue&type=template&id=24b3c5da&scoped=true"
import script from "./HandoverDevicesStep.vue?vue&type=script&lang=ts"
export * from "./HandoverDevicesStep.vue?vue&type=script&lang=ts"
import style0 from "./HandoverDevicesStep.vue?vue&type=style&index=0&id=24b3c5da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b3c5da",
  null
  
)

export default component.exports